import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'protocol-settings',
	templateUrl: './protocol-settings.component.html',
    styleUrls: ['./protocol-settings.component.scss']
})
export class ProtocolSettingsComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }
}
